import { css } from 'styled-components';
const BarlowCondensedFontFaces = css `

    /* Barlow Condensed - Normal */
    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-SemiBold.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-Bold.ttf') format('truetype');
        font-weight: Bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-ExtraBold.ttf') format('truetype');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-Medium.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-Light.ttf') format('truetype');
        font-weight: 200;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-ExtraLight.ttf') format('truetype');
        font-weight: lighter;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-Thin.ttf') format('truetype');
        font-weight: 100;
        font-style: normal;
        font-display: swap;
    }

    /* Barlow Condensed - Italic */
    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-SemiBoldItalic.ttf') format('truetype');
        font-weight: 600;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-BoldItalic.ttf') format('truetype');
        font-weight: Bold;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-ExtraBoldItalic.ttf') format('truetype');
        font-weight: 800;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-ExtraLightItalic.ttf') format('truetype');
        font-weight: 500;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-MediumItalic.ttf') format('truetype');
        font-weight: 200;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-ExtraLightItalic.ttf') format('truetype');
        font-weight: lighter;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Barlow Condensed';
        src: url('/fonts/BarlowCondensed-ThinItalic.ttf') format('truetype');
        font-weight: 100;
        font-style: italic;
        font-display: swap;
    }
`;
export default BarlowCondensedFontFaces;
//# sourceMappingURL=BarlowCondensed.js.map